import { sortStrings } from '~/utils/sortStrings';

import { LibraryModel, LibraryModelVersion } from './types';

export const getLatestModelVersions = (models: LibraryModel[]) =>
  models.flatMap((model) => model.versions.filter((version) => version.latest));

export const getSortedCategoryModels = (
  models: LibraryModelVersion[],
): Map<string, LibraryModelVersion[]> => {
  const categoryModels = new Map<string, LibraryModelVersion[]>();
  models.forEach((model) => {
    const label = model.tags?.[0]?.label ?? 'Uncategorized';
    if (categoryModels.has(label)) {
      categoryModels.set(label, [...(categoryModels.get(label) ?? []), model]);
    } else {
      categoryModels.set(label, [model]);
    }
  });
  const labels = Array.from(categoryModels.entries());
  const sortedLabels = labels.sort((a, b) => sortStrings(a[0], b[0]));

  return new Map<string, LibraryModelVersion[]>(sortedLabels);
};
